import React from "react"
import { useHistory } from "react-router-dom"
import { BookingFlowError } from "@internal/telemedicine"
import { PageLayout } from "#/features/global-ui/page-layout"
import { createErrorBoundary } from "#/utils/createErrorBoundary"
import { Paths } from "#/utils/Paths"

function TelemedicineFlowErrorFallback({ unsetError }: { unsetError: () => void }): JSX.Element {
  const history = useHistory()
  return (
    <PageLayout variant="default">
      <BookingFlowError onRetry={unsetError} onExit={() => history.push(Paths.HOME)} />
    </PageLayout>
  )
}

export const TelemedicineFlowErrorBoundary = createErrorBoundary(
  TelemedicineFlowErrorFallback,
  "TelemedicineBookingFlow"
)
